<div class="banner">
  <div class="container">
    <div class="header">
      <div class="row header_mid">
        <div class="col-lg-3 col-md-4">
          <div class="header_left" data-aos="fade-right">
            You Are Invited By <br />
            {{ userName }}
          </div>
        </div>
        <div class="header_right">
          <ul>
            <li data-aos="fade-right">
              <a
                [routerLink]="'.'"
                [queryParams]="{ reg: referralId }"
                [fragment]="'regform'"
                class="go"
                ><i class="fas fa-edit fa-1x"></i> Signup</a
              >
            </li>
            <!-- <li data-aos="fade-left"><a routerLink="/login"><i class="fas fa-sign-in-alt fa-2x"></i> Signin</a></li> -->
          </ul>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="banner_left_box">
          <div class="logo" data-aos="fade-down">
            <img
              src="{{ myLinksS3URL }}frontend/presentation22/images/logo.png"
              class="img-fluid"
              alt="image"
            />
          </div>
          <h1 data-aos="fade-right" id="text">
            Looking for a self-driving business opportunity?
          </h1>
          <h2 data-aos="fade-left">
            A plug & <span>play system to earn residual income</span>
          </h2>
          <p data-aos="fade-up">
            Presenting a real business generating platform where you can use
            your entrepreneurship mentality to replace your income. The POWER of
            the INTERNET backed up by the latest AI technology brings you
            something that is so powerful that you can sit back and enjoy a
            smooth ride in earning lifetime residual income.
          </p>
          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'regform'"
            class="btn11"
            data-aos="zoom-in"
          >
            <span>BECOME A FOUNDER NOW</span>

            <div class="transition"></div>
          </a>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="right_banner" data-aos="zoom-in">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation14/images/right_man_image.png"
            class="img-fluid"
            alt="image"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="sec_two">
  <h1 data-aos="fade-right">
    Now Open in <span id="city">{{ city }}</span
    >, <span id="country">{{ country }}</span> <br />

    <input
      type="hidden"
      id="ipadress"
      name="ipadress"
      value="14.97.11.70, 192.180.10.18"
    />
    <input
      type="hidden"
      id="key"
      name="key"
      value="56e0d8aaef9f0c485ac454467477cbd3"
    />
    <br />Worldwide Priority Placement Available
  </h1>

  <div class="row">
    <div class="col-lg-10">
      <div class="sec_two_mid_box">
        <div class="sec_two_first_box">
          <div class="sec_two_first_left_image" data-aos="fade-up">
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation14/images/left_first_image.png"
              class="img-fluid"
              alt="image"
            />
          </div>

          <div class="sec_two_right_box">
            <div class="sec_two_right_box_first" data-aos="fade-right">
              <h1>
                A revolutionary, stand-alone, AI driven, Online Marketing
                Business Solution
              </h1>
              <h6>
                It is a brand new, never-before-seen technology perfectly
                integrated into a complete system.
              </h6>
              <p>
                'You cannot change your destination overnight, but you can
                change your direction overnight'. Grab this chance to change
                your life and make your dreams come true.
              </p>
              <p>
                The adjacent video introduces you to this mind-blowing concept
              </p>
              <a
                [routerLink]="'.'"
                [queryParams]="{ reg: referralId }"
                [fragment]="'regform'"
                class="btn12"
              >
                <span>BECOME A FOUNDER NOW</span>

                <div class="transition"></div>
              </a>
            </div>
            <div class="video_image" data-aos="fade-left">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation14/images/video_image.jpg"
                class="img-fliud"
                alt="image"
              />
              <div class="play_button">
                <a
                  href="#"
                  data-toggle="modal"
                  data-backdrop="static"
                  data-keyboard="false"
                  data-target="#myModal1"
                  ><img
                    src="{{
                      myLinksS3URL
                    }}frontend/presentation14/images/play_buton.png"
                    class="img-fluid"
                    alt="image"
                /></a>
              </div>
            </div>
          </div>
        </div>

        <div class="sec_two_first_box">
          <div class="sec_two_first_left_image" data-aos="fade-up">
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation14/images/left_sec_image.png"
              class="img-fluid"
              alt="image"
            />
          </div>

          <div class="sec_two_right_box">
            <div class="sec_two_right_box_first" data-aos="fade-right">
              <h1>
                A UNIQUE SET IT & FORGET IT PLATFORM THAT HAS EVERYTHING
                INSTALLED AND CONFIGURED FOR
              </h1>
              <div class="left">
                <ul>
                  <li>Regular Income</li>
                  <li>Unique Visitors</li>
                </ul>
              </div>
              <div class="left">
                <ul>
                  <li>Product Selling</li>
                  <li>Building Business</li>
                </ul>
              </div>
              <p>
                The following video provides further information on this unique
                platform
              </p>
              <a
                [routerLink]="'.'"
                [queryParams]="{ reg: referralId }"
                [fragment]="'regform'"
                class="btn12"
              >
                <span>BECOME A FOUNDER NOW</span>

                <div class="transition"></div>
              </a>
            </div>
            <div class="video_image" data-aos="fade-left">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation14/images/video_image_two.jpg"
                class="img-fliud"
                alt="image"
              />
              <div class="play_button">
                <a
                  href="#"
                  data-toggle="modal"
                  data-backdrop="static"
                  data-keyboard="false"
                  data-target="#myModal2"
                  ><img
                    src="{{
                      myLinksS3URL
                    }}frontend/presentation14/images/play_buton.png"
                    class="img-fluid"
                    alt="image"
                /></a>
              </div>
            </div>
          </div>
        </div>

        <div class="sec_two_first_box">
          <div class="sec_two_first_left_image" data-aos="fade-up">
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation14/images/left_third_image.png"
              class="img-fluid"
              alt="image"
            />
          </div>

          <div class="sec_two_right_box">
            <div class="sec_two_right_box_first" data-aos="fade-right">
              <h1>Are you dissatisfied with your income?</h1>
              <h6>MAKING MONEY IS EASY NOW</h6>
              <p>
                As per statistics, one in every four people wants to move to
                better job. Millions of people are unhappy today. Some have
                unrewarding career while others look for job stability. Many
                have to work for longer hours for lesser pay while some look for
                a more reliable job.
              </p>
              <p>
                This is the last golden chance to change your life for better
                and forget the insecurities.
              </p>
              <a
                [routerLink]="'.'"
                [queryParams]="{ reg: referralId }"
                [fragment]="'regform'"
                class="btn12"
              >
                <span>BECOME A FOUNDER NOW</span>

                <div class="transition"></div>
              </a>
            </div>
            <div class="video_image" data-aos="fade-left">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation14/images/video_image_three.jpg"
                class="img-fliud"
                alt="image"
              />
              <div class="play_button">
                <a
                  href="#"
                  data-toggle="modal"
                  data-backdrop="static"
                  data-keyboard="false"
                  data-target="#myModal3"
                  ><img
                    src="{{
                      myLinksS3URL
                    }}frontend/presentation14/images/play_buton.png"
                    class="img-fluid"
                    alt="image"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="sec_three">
  <div class="sec_three_left" data-aos="fade-right">
    <h1>Are you worried because you are not a marketer?</h1>
    <p>
      We have got you covered. You will not have to recruit, sell, promote or
      anything else if you don’t want to… but you can earn much more if you do.
      The database, the people that you have added, they are going to be in your
      business which is the true residual business model.
    </p>
    <h1>Are you a marketer? Wonderful!! Here is a nugget for you:</h1>
    <!--<ul>
          <li>An Upgraded Marketing Automation</li>
 
<li>Guaranteed Web Traffic</li>
 
<li>Instant Earnings</li>
          </ul>-->
    <p>
      It is your business. Get unique domain names and hosting or choose one as
      per your choice and every other tool that you will need to successfully
      build your business.
    </p>
  </div>
  <div class="sec_three_right" data-aos="fade-left">
    <h1>Is changing your life important to you?</h1>
    <h6>
      I know it is and therefore I am gifting you this opportunity. Do not make
      excuses. If you lose this opportunity, it is lost forever. <br /><br />
      The Founders position is still open and only a few seats are left. Pay
      only $97 instead of $997 (90% discount as introductory offer) and secure
      your position. There might not be any seats left once the business
      launches and if available it would cost more. <br /><br />
      I advise you not to delay but to join me immediately on this wonderful
      journey. I guarantee you that this is completely safe, legit and
      complaint. What’s more is that if you are unhappy, I assure you 100%
      lifetime money-back guarantee.
    </h6>
    <!--<div class="sec_three_bottom">
              <p>YOU CAN WAIT FOR THE BUSINESS TO LAUNCH. YOU CAN SELECT A BUSINESS PACKAGE FOR $25 AND BECOME A FOUNDER. HOWEVER, THIS 'FOUNDER' POSITION DEPENDS ON THE AVAILABILITY OF THE SPOTS.</p>
                  <p>REQUEST A FOUNDERS POSITION NOW FOR A 90% DISCOUNTED ONE-TIME FEE OF $97 TO JOIN THE 1% AT THE TOP BEFORE THE ENTIRE MARKET JOINS. HIGHLY RECOMMENDED!</p>
              </div>-->
  </div>
</div>

<div class="container">
  <div class="sec_four">
    <div class="row header_mid">
      <div class="col-md-7">
        <div class="sec_four_left_box">
          <h1 data-aos="fade-up">
            A simple two-step registration process within two minutes
          </h1>
          <div class="row">
            <div class="col-lg-6">
              <div class="reg_first_box" data-aos="flip-up">
                We just require your basic details for the registration form
              </div>
            </div>
            <div class="col-lg-6">
              <div class="reg_first_box" data-aos="flip-left">
                We accept payments through Card, Bitcoin and even More
              </div>
            </div>
          </div>
          <h1>You are instantly confirmed as a FOUNDER!</h1>
        </div>
      </div>

      <div class="col-md-4">
        <div class="sec_four_right_image" data-aos="zoom-in">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation14/images/sec_four_right_image.jpg"
            class="img-fluid"
            alt="image"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="sec_five">
  <div class="sec_five_left" data-aos="fade-right">
    <h1>WEBINAR</h1>
    <a
      href="#"
      data-toggle="modal"
      data-backdrop="static"
      data-keyboard="false"
      data-target="#previous"
      class="webiner_button"
      ><img
        src="{{ myLinksS3URL }}frontend/presentation14/images/play_button.png"
        class="img-fluid"
        alt="image"
      />
      PREVIOUS WEBINAR PLAYBACK</a
    >
  </div>
  <div class="sec_five_right" data-aos="fade-left">
    <h1>Welcome Founder! Access a plethora of benefits</h1>
    <ul class="text-white">
      <li>Customized dashboard updated with necessary information</li>
      <li>All necessary links to invite your friends and relatives</li>
      <li>Regular private meetings and live webinars by top leaders</li>
      <li>Updates from visionary Mr. Mufareh to help you profit more</li>
      <li>Exciting contests offering lucrative cash bonus and perks</li>
    </ul>
    <h2>
      The key to success is action, and the essential in action is perseverance
    </h2>
    <a
      class="btn sign_up"
      routerLink="/auth/login"
      target="_blank"
      rel="noopener"
      >Sign In</a
    >
  </div>
</div>

<div class="form_box" id="regform">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-7">
        <div
          class="form_mid_box"
          data-aos="fade-up"
          id="reg_form"
          data-aos-duration="1500"
        >
          <div class="logo_one mx-auto">
            <img
              src="{{ myLinksS3URL }}frontend/presentation22/images/logo.png"
              class="img-fluid"
              alt="image"
            />
          </div>
          <h1>REGISTER</h1>

          <div class="panel-group cst"></div>

          <form [formGroup]="registerForm">
            <div class="row reg">
              <div class="col-md-6">
                <div class="d-block">
                  <input
                    matInput
                    type="text"
                    class="log_in_fild"
                    placeholder="First Name"
                    formControlName="firstname"
                    required
                  /><br />
                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError('required') &&
                      registerForm.controls['firstname'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    First Name Required.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError('maxlength')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Min 1, max 50 characters.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containOnlyNumbers'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only numbers are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containOnlySpecialChars'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only special characters are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveSpaces'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive spaces are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveDots'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dots are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveHyphens'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dashes are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveUnderScores'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive underscores are not allowed.
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-block">
                  <input
                    matInput
                    type="text"
                    placeholder="Last Name"
                    class="log_in_fild"
                    formControlName="lastname"
                    required
                  />
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError('required') &&
                      registerForm.controls['lastname'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Last Name Required.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError('maxlength')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Min 1, max 50 characters.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containOnlyNumbers'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only numbers are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containOnlySpecialChars'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only special characters are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveSpaces'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive spaces are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveDots'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dots are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveHyphens'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dashes are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveUnderScores'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive underscores are not allowed.
                  </span>
                </div>
              </div>
            </div>

            <div class="d-block">
              <input
                matInput
                type="text"
                placeholder="Email Address"
                class="log_in_fild"
                formControlName="email"
                required
              />

              <span
                *ngIf="
                  registerForm.controls['email'].hasError('required') &&
                  registerForm.controls['email'].touched
                "
                class="failed-validation"
                style="color: red"
              >
                Email id Required.
              </span>
              <span
                *ngIf="registerForm.controls['email'].hasError('pattern')"
                class="failed-validation"
                style="color: red"
              >
                Please enter valid email.
              </span>
              <!-- <span *ngIf="registerForm.controls['email'].hasError('maxLength')" 
                           class="failed-validation" style="color: red">
                            Email length sould be less than 100.
                          </span>-->
            </div>

            <div class="form-group d-block">
              <div class="password-block">
                <input
                  matInput
                  placeholder="Password"
                  formControlName="password"
                  class="log_in_fild"
                  [type]="pwdToggle ? 'text' : 'password'"
                  required
                />
                <button
                  type="button"
                  class="password-icon"
                  (click)="pwdToggle = !pwdToggle"
                >
                  <i
                    class="fal"
                    [ngClass]="{
                      'fa-eye': pwdToggle,
                      'fa-eye-slash': !pwdToggle
                    }"
                  ></i>
                </button>
              </div>
              <span
                *ngIf="
                  registerForm.controls['password'].hasError('required') &&
                  registerForm.controls['password'].touched
                "
                class="failed-validation"
                style="color: red"
              >
                Password Required
              </span>
              <span
                *ngIf="registerForm.controls['password'].hasError('pattern')"
                class="failed-validation"
                style="color: red"
              >
                Password should contain minimum 8 Characters and Atleast one
                Uppercase, One Lowercase, one Number and one Special Characters
              </span>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="d-block">
                  <input
                    matInput
                    type="text"
                    placeholder="Phone Number"
                    class="log_in_fild"
                    formControlName="phone"
                    onKeyPress="if(this.value.length==20) return false;"
                    onkeydown="return event.keyCode !== 69"
                    required
                  />
                  <span
                    *ngIf="
                      registerForm.controls['phone'].hasError('required') &&
                      registerForm.controls['phone'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Phone number is required.
                  </span>
                  <span
                    *ngIf="registerForm.controls['phone'].hasError('pattern')"
                    class="failed-validation"
                    style="color: red"
                  >
                    Only numbers are allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['phone'].hasError('minlength') ||
                      registerForm.controls['phone'].hasError('maxlength')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Min 6 and max 20 digits.
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-block">
                  <select
                    formControlName="country_id"
                    required
                    class="log_in_fild"
                  >
                    <option value="">Select Country</option>
                    <option
                      *ngFor="let country of countriesList"
                      [value]="country.countryId"
                    >
                      {{ country.countryName }}
                    </option>
                  </select>
                  <span
                    *ngIf="
                      registerForm.controls['country_id'].hasError(
                        'required'
                      ) && registerForm.controls['country_id'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Plese Select Country
                  </span>
                </div>
              </div>
            </div>
            <!-- <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="row no-gutters">
                                        <div class="capcha">
                                            <img [src]="imageCaptcha" style="width: 120px" />
                                        </div>

                                        <div class="serc">
                                            <i class="fa fa-refresh fa-lg" aria-hidden="true" (click)="regenerateCaptcha()"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="main input-effect">
                                        <input id="capcha" maxlength="5" name="capcha" type="text" formControlName="enteredCaptcha" placeholder=" Enter Captcha" class="form-control effect-19" required="required" />
                                        <span *ngIf="
                        registerForm.controls['enteredCaptcha'].hasError(
                          'required'
                        ) && registerForm.controls['enteredCaptcha'].touched
                      " class="failed-validation" style="color: red">
                      Captcha Required
                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>-->
            <div class="text-center">
              <button
                mat-raised-button
                type="submit"
                (click)="submitRegister()"
                [disabled]="registerForm.invalid"
                class="ibtn"
              >
                SignUp
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="testimonilas">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <h1>TESTIMONIALS</h1>
      </div>

      <!--TESTIMONIALS PART OPEN-->

      <div class="testimonials_bg">
        <div class="container">
          <div class="testimonilas_box">
            <div class="testimonial-container">
              <div class="dk-container">
                <div class="cd-testimonials-wrapper cd-container">
                  <ul class="cd-testimonials">
                    <li>
                      <div class="testimonial-content">
                        <div class="cd-author">
                          <img
                            src="{{ cloudFrontUrl }}uploads/t1.png"
                            alt="Author image"
                          />
                        </div>

                        <div class="right_box">
                          <h2>An ideal model for anyone</h2>

                          <ul class="cd-author-info">
                            <li>Tim <strong>Leach</strong></li>

                            <li></li>
                          </ul>

                          <p>
                            His drive and passion for creating a platform to
                            help everyone from seasoned marketers to the "little
                            guy" helped solidify my belief Then learning how we
                            benefit financially with optional starting points,
                            makes this an ideal model for anyone with a business
                            who needs advertising.
                          </p>

                          <p>
                            Thank you Ash for your vision and help for so many
                            people around the world.
                          </p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div class="testimonial-content">
                        <div class="cd-author">
                          <img
                            src="{{ cloudFrontUrl }}uploads/t4.png"
                            alt="Author image"
                          />
                        </div>

                        <div class="right_box">
                          <h2>This Will Undoubtedly Change Your Life!</h2>

                          <ul class="cd-author-info">
                            <li>Mike <strong>Williams</strong></li>

                            <li></li>
                          </ul>

                          <p>
                            I want to personally say thank you to everyone on
                            this awesome journey that Ash Murareh has created.
                            As many of you may not know, Ash is a very
                            successful online marketer and has made his living
                            in this industry building massive teams for various
                            companies. He saw a big need for creating a company
                            that would help the average person succeed online so
                            he decided to build it himself.
                          </p>

                          <p>
                            When you listen to his Founder's presentations or
                            when you speak with him, you will immediately feel
                            his passion to build a highly effective business
                            where every single person will be successful.
                          </p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div class="testimonial-content">
                        <div class="cd-author">
                          <img
                            src="{{ cloudFrontUrl }}uploads/t2.png"
                            alt="Author image"
                          />
                        </div>

                        <div class="right_box">
                          <h2>
                            I am totally blown away and will build my final
                            dynasty here in ONPASSIVE
                          </h2>

                          <ul class="cd-author-info">
                            <li>PRINCE <strong>OBI</strong></li>

                            <li></li>
                          </ul>

                          <p>
                            In my 19 years successful career in this space,I
                            have never seen a business so full, so disruptive,
                            so intriguing that everyone I approach is excited to
                            belong.
                          </p>

                          <p>
                            Did a Facebook post, alongside my WhatsApp campaign,
                            on the founder position, that attracted 122
                            comments, 14 people have joined direct to me and in
                            less than 48 hours, 59 super qualified leads have
                            submitted their email, requesting information to be
                            founders, AND ALL THESE WITHOUT ANYTHING YET
                            ONGROUND, not even a website. I am totally blown
                            away and will build my final dynasty here in
                            ONPASSIVE.
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- cd-testimonials -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--TESTIMONIALS PART CLOSED-->
    </div>
  </div>
</div>

<div class="footer">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>FOR A LITTLE WHILE YET, FOUNDER POSITIONS STILL AVAILABLE!</h1>
        <h6>Copyright O-Founders 2022</h6>
      </div>
    </div>
  </div>
</div>

<div id="myModal1" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="first_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video1.pause(); video1.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video1
        id="my-video"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting1-new.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="myModal2" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="second_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video2.pause(); video2.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video2
        id="my-video1"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/greetingsgofound/images/greeting2.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/Video2-Compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="myModal3" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="third_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video3.pause(); video3.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video3
        id="my-video2"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting3-new.png"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="previous" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          id="prev_video_pause"
          (click)="video4.pause(); video4.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video4
        width="100%"
        class="video-js"
        controls
        preload="auto"
        poster="{{ myLinksS3URL }}videos/title.jpg"
        id="my-video"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          id="video"
          type="video/mp4"
        />

        Your browser does not support HTML5 video.
      </video>
    </div>
  </div>
</div>

<div class="country_popup_wrapper"></div>
